import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import fetchAllItems from '@product-framework/utils/fetchAllItems';
import { LoadingEvent } from '@ui-framework/index';
import { useEffect, useState } from 'react';

function UnPaginatedList({
  title,
  getItems = () => undefined,
  items = null,
  parentId = null,
}) {
  const [dataSet, setDataSet] = useState({ data: [] });
  const [loading, setLoading] = useState(true);

  const fetchReadOnlyItems = async () => {
    setLoading(true);
    const itemsFound = await fetchAllItems(getItems);
    setDataSet(itemsFound);
    setLoading(false);
  };

  useEffect(() => {
    if (!items) {
      fetchReadOnlyItems();
    } else {
      setDataSet({ data: items });
      setLoading(false);
    }
  }, [parentId, items]);

  return (
    <Box textAlign="left">
      <Box>
        <Typography variant="body1" sx={{ fontWeight: 500 }} gutterBottom>
          {title}
        </Typography>
      </Box>
      {loading && <LoadingEvent>...loading</LoadingEvent>}
      {!loading && dataSet?.data?.length > 0 ? (
        <List sx={{ listStyleType: 'disc', pl: 3, pt: 1 }}>
          {dataSet?.data?.map(item => {
            return (
              <ListItem
                key={item?.label}
                sx={{ display: 'list-item', pl: 0, m: 0, py: 0 }}>
                <ListItemText sx={{ fontSize: '0.9em' }}>
                  {item?.label}
                </ListItemText>
              </ListItem>
            );
          })}
        </List>
      ) : (
        <Typography variant="body1" gutterBottom>
          No data found
        </Typography>
      )}
    </Box>
  );
}

export default UnPaginatedList;
